import React from 'react';
import ReactDOM from 'react-dom/client';
import PromptForge from './PromptForge';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PromptForge />
  </React.StrictMode>
);
